import { Obj, load } from "scrivito"

export async function loadScrivitoChildren<ParentObjType extends Obj>(
  obj: ParentObjType,
  depth = 1,
  predicate?: (obj: Obj) => boolean
): Promise<Obj[]> {
  let children: Obj[] = await load(() => obj.orderedChildren() as Obj[])

  await Promise.all(children.map(child => load(() => child.parent())))

  if (predicate) {
    children = children.filter(predicate)
  }
  if (depth === 1) {
    return children
  }

  const grandChildren = await Promise.all(
    children.map((child: Obj) =>
      loadScrivitoChildren(child, depth - 1, predicate)
    )
  )
  return grandChildren.flatMap(c => c)
}
